import { render } from "./InvoicesOverview.vue?vue&type=template&id=c002406e"
import script from "./InvoicesOverview.vue?vue&type=script&lang=js"
export * from "./InvoicesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__